





































































































import {
  Vue, Component,
} from 'vue-property-decorator';
import { eventBus } from '../../main';
import { SHOW_SNACKBAR } from '../../common/constants';
import errorModule from '../../store/modules/error.module';
import budtenderModule from '../../store/modules/budtender.module';
import Budtender from '../../../../backend/app/model/entity/Budtender';

@Component({
  components: {},
})
export default class BudtenderUserListPage extends Vue {
  selectedUser: Budtender | undefined = undefined;

  removeUserTitle = '';

  removeUserBody =
    "By removing this user, they will no longer have access to the dispensary's shelf.";

  deleteUserDialog = false;

  search = '';

  headers = [
    { text: 'Full Name', value: 'full_name' },
    { text: 'Email', value: 'email' },
    { text: 'Status', value: 'activateText' },
    { text: 'Actions', value: 'actions', sortable: false },
  ];

  addUserDialog = false;

  addUserTitle = 'Invite User to Your Dispensary';

  userStatuses: Array<string> = [];

  newUserEmail = '';

  brandName = '';

  get dispensaryUsers(): Array<Budtender> {
    if (!budtenderModule.dispensary) {
      return [];
    }
    if (!budtenderModule.dispensary.budtenders) {
      return [];
    }
    const rawUsers: Array<any> = [];
    for (
      let userIndex = 0;
      userIndex < budtenderModule.dispensary.budtenders.length;
      userIndex += 1
    ) {
      rawUsers[userIndex] = {
        ...budtenderModule.dispensary.budtenders[userIndex],
      };
      const status = rawUsers[userIndex].activated;
      rawUsers[userIndex].activateText = status ? 'Activated' : 'Invite Sent';
    }
    return rawUsers;
  }

  deleteUser(user: Budtender): void {
    this.removeUserTitle = `Remove ${user.full_name}`;
    this.deleteUserDialog = true;
    this.selectedUser = user;
  }

  addUser(): void {
    if (!budtenderModule.dispensary) {
      return;
    }
    this.addUserTitle = `Invite User to ${budtenderModule.dispensary.name}`;
    this.addUserDialog = true;
  }

  async inviteUserConfirmed(): Promise<void> {
    if (
      this.newUserEmail.length < 5
      || !this.newUserEmail.includes('@')
      || !this.newUserEmail.includes('.')
    ) {
      eventBus.$emit(SHOW_SNACKBAR, 'Please enter a valid email address.');
      return;
    }
    if (!budtenderModule.dispensary) {
      return;
    }
    const dispensaryId = budtenderModule.dispensary.id;
    await budtenderModule.inviteBudtender({
      dispensaryId,
      inviteEmail: this.newUserEmail,
    });
    if (errorModule.hasError) {
      errorModule.clearError();
      return;
    }

    this.addUserDialog = false;
    eventBus.$emit(SHOW_SNACKBAR, `Invitation sent to ${this.newUserEmail}.`);
    // Empty string for next entry.
    this.newUserEmail = '';
  }

  sendEmail(user: Budtender): void {
    this.selectedUser = user;
    location.href = `mailto:${user.email}`;
  }

  async deleteConfirmed(): Promise<void> {
    if (!this.selectedUser) {
      return;
    }
    this.deleteUserDialog = false;
    // Remove dispensary from list
    eventBus.$emit(
      SHOW_SNACKBAR,
      `Successfully removed ${this.selectedUser.full_name} from your brand.`,
    );
  }
}
